import DevLogger from '@/helpers/dev-logger';

export default ({ app }) => {
    if (app.router.suppressMiddleware) {
        DevLogger.log('Removed suppressed middleware flag');
        delete app.router.suppressMiddleware;
    }
};
